module.exports = __webpack_public_path__ + "img/bg_video1.f1932998.png";